import { BaseIconProps } from "../../types/styles";

const SearchIcon = ({
    id,
    className,
    size = 24,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-500)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-search"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="m21 21-4.34-4.34" />
            <circle cx="11" cy="11" r="8" />
        </svg>
    );
};

export default SearchIcon;
